import React from 'react';
import coinIcon from '../../../../../assets/svg/coins.svg';

const NoCommission = () => {
  return (
    <div style={{ textAlign: 'center', marginTop: 100 }}>
      <img src={coinIcon} alt="تراکنشی یافت نشد." height={60} width={60} />
      <div>ضریبی پیدا نشد. از منوی بغل برای افزودن ضریب استفاده کنید.</div>
    </div>
  );
};

export default React.memo(NoCommission);
